module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.existBilling) ? _c('div', {
    staticClass: "my-1 summary-order-grid fontS14"
  }, [_c('div', [_c('billing-svg')], 1), _vm._v(" "), _c('div', {
    staticClass: "line-height-2 d-flex flex-column"
  }, [_c('h4', {
    staticClass: "my-0 fontAvenirBold"
  }, [_vm._v("Solicitud de factura")]), _vm._v(" "), _c('span', {
    staticClass: "fontS13"
  }, [_vm._v("RUC: "), _c('span', {
    staticClass: "fontOpenBold"
  }, [_vm._v(_vm._s(_vm.billingData.ruc))])]), _vm._v(" "), _c('span', {
    staticClass: "fontS13"
  }, [_vm._v("Razón social: "), _c('span', {
    staticClass: "fontOpenBold"
  }, [_vm._v(_vm._s(_vm.billingData.rzSocial))])]), _vm._v(" "), _c('span', {
    staticClass: "fontS13"
  }, [_vm._v("Domicilio Fiscal: "), _c('span', {
    staticClass: "fontOpenBold"
  }, [_vm._v(_vm._s(_vm.billingData.address))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f129c0d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/billingData.vue
// module id = 1101
// module chunks = 30